export default __webpack_public_path__ + "static/media/landingPageBG-desktop.a43678ca.jpg";